<template>
<div>
    <div v-if="showLoader" class="headerClass">
        <div class="spinner-overlay">
            <div style="position:absolute"></div>
            <div class="spinner-flex">
                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                </svg>
            </div>
        </div>
    </div>
    <!-- Make container scrollable if content overflows -->
    <div class="scrollable-container" v-if="!showLoader">
        <router-view></router-view>
    </div>
</div>
</template>

<script>
import axios from "axios";
import {
    EventBus
} from "../services/event-bus.js";
import constants from "../constants";
export default {
    name: "MainPageStandalone",
    data() {
        return {
            showLoader: false
        };
    },
    beforeDestroy () {
        EventBus.$off('success-notification')
        EventBus.$off('error-notification')
        EventBus.$off('warning-notification-static')
        EventBus.$off('warning-notification')
        EventBus.$off('update-pageTitle')
    },
    created() {
        this.countDownTimer(18000);
        let self = this;
        self.showLoader = true;
        EventBus.$on("update-pageTitle", result => {
            let pageTitle = result;
            document.title = pageTitle;
        });
        EventBus.$on("success-notification", result => {
            self.showToast('success', result.msg)
        });
        EventBus.$on("error-notification", result => {
            self.showToast('danger', result.msg)
        });
        EventBus.$on("warning-notification-static", result => {
            self.showToast('warning', result.msg)
        });
        EventBus.$on("warning-notification", result => {
            self.showToast('warning', result.msg)
        });
        this.configureRefreshSession();
        if (self.$route.params.standalone == "standalone") {
            if (self.$route.params.processOrTask == "tasks") {
                axios.get(constants.BASE_URL + "/standalone/external/checkSecure/task/" + self.$route.params.taskId, {
                        withCredentials: true
                    })
                    .then(response => {
                        if (response.data && response.data.standaloneForm == "true") {
                            if (self.$route.params.external == "external") {
                                if (response.data && response.data.secureForm == "true") {
                                    self.init("task");
                                } else {
                                    self.showLoader = false;
                                }
                            } else {
                                self.init("task");
                            }
                        } else {
                            self.$router.push(
                                process.env.VUE_APP_CONTEXT_PATH + "/tasks/viewtask/all involved/" + self.$route.params.taskId
                            );
                        }
                    });
            } else {
                axios.get(constants.BASE_URL + "/standalone/external/checkSecure/process/" + self.$route.params.definitionId, {
                        withCredentials: false
                    })
                    .then(response => {
                        if (response.data && response.data.secureForm == "true") {
                            self.init("process");
                        } else {
                            self.showLoader = false;
                        }
                    })
                    .catch(error => {
                        self.showLoader = false;

            
                        localStorage.setItem("returnUrl", self.$router.currentRoute.path);
                        window.location = process.env.VUE_APP_CONTEXT_PATH + "/login";

                          
                    });
            }
        } else {
            self.$router.push(process.env.VUE_APP_CONTEXT_PATH + "/notFound");
        }
    },
    methods: {
        showToast(color, title) {
            const getIcon = (color) => {
                switch (color) {
                    case 'info':
                        return 'info_popup'
                    case 'success':
                        return 'ok'
                    case 'warning':
                        return 'error'
                    case 'danger':
                        return 'stop_sign'
                    case 'primary':
                        return 'page'
                    default:
                        return 'not_found'
                }
            }

            const buildToastText = () => {
                return `
                <mcc-icon name="${getIcon(color)}" icon-set="fluency-filled" aria-hidden="true"></mcc-icon>
                <div class="mu-d-flex mu-flex-column">
                    <div class="mu-fw-semi-bold">${title}</div>
                </div>
                `
            }

            Toastify({
                text: buildToastText(),
                escapeMarkup: false,
                duration: 5000,
                newWindow: true,
                close: true,
                className: `mcc-alert  mcc-alert--${color} [mu-d-flex mu-flex-row mu-p-04 mu-px-05]`,
                gravity: "top",
                position: "right",
                stopOnFocus: true,
            }).showToast()
        },
        init(type) {
            let self = this;

            axios.get(constants.BASE_URL + "/usersgroups/usersAPI/init", {
                    withCredentials: true
                })
                .then(() => {
                    if (type == "process") {
                        //let procDef = self.$route.params.definitionId.split('-')[self.$route.params.definitionId.split('-').length - 1];
                        self.$router.push(
                            process.env.VUE_APP_CONTEXT_PATH + "/standalone/secure/processes/viewprocess/" + self.$route.params.definitionId.toString()
                        );
                    } else {
                        self.$router.push(
                            process.env.VUE_APP_CONTEXT_PATH + "/standalone/secure/tasks/viewtask/" + self.$route.params.taskId
                        );
                    }
                })
                .catch((error) => {
                    if (error === 'login') {
                        localStorage.setItem("returnUrl", self.$router.currentRoute.path);
                        window.location = process.env.VUE_APP_CONTEXT_PATH + "/login";
                    } else {
                        localStorage.setItem("oldURL", self.$router.currentRoute.path);
                        window.location = process.env.VUE_APP_CONTEXT_PATH + "/unauthorizedError";
                    }
                })
                .finally(() => {
                    self.showLoader = false;
                });
        },
        configureRefreshSession() {
            const tokenRefreshUrl = process.env.VUE_APP_CONTEXT_PATH + "/tokenrefresh";
            axios.interceptors.response.use(
                response => (response),
                async error => {
                    const originalConfig = error.config;

                    if (error.response) {
                        if (error.response.status === 401) {
                            if (error.response.config.url === tokenRefreshUrl) {
                                return Promise.reject('login');
                            } else if (!originalConfig._retry) {
                                originalConfig._retry = true;

                                try {
                                    await axios.get(tokenRefreshUrl, {
                                        withCredentials: true
                                    });
                                    return axios(originalConfig);
                                } catch (_error) {
                                    if (_error.response && _error.response.data) {
                                        return Promise.reject(_error.response.data);
                                    }
                                    return Promise.reject(_error);
                                }
                            }
                        }
                        if (error.response.status === 403 && error.response.data) {
                            return Promise.reject(error.response.data);
                        }
                    }
                    return Promise.reject(error);
                }
            );
        },
        countDownTimer(timer) {
            const currentUrl = window.location.pathname;
            if (currentUrl.includes("secure")) {
                if (timer > 0) {
                    setTimeout(() => {
                        timer -= 1
                        this.countDownTimer(timer)
                    }, 1000)
                } else {

                    axios.get(process.env.VUE_APP_CONTEXT_PATH + "/tokenrefresh", {
                            withCredentials: true
                        })
                        .then(() => {
                            this.countDownTimer(18000)
                        })
                        .catch((error) => {
                            EventBus.$emit("warning-notification-static", {
                                msg: 'Your session has expired, please login again!'
                            });
                        })
                }
            }
        }
    }
};
</script>

<style scoped>
.headerClass {
    position: relative;
    width: 100vw;
    height: 100vh;
}
 
.headerClass {
    position: relative;
    width: 100vw;
    height: 100vh;
}

.scrollable-container {
    max-height: calc(100vh);
    overflow-y: auto;
    padding: 10px;
}
</style>
